import { useLayoutEffect } from 'react'

export function useUpdateVersion() {
  useLayoutEffect(() => {
    const currentVersion = process.env.REACT_APP_BUILD_VERSION
    const localStorageVersion = localStorage.getItem('build_version')
    if (currentVersion && currentVersion !== localStorageVersion) {
      localStorage.setItem('build_version', currentVersion)
    }
  }, [])
}
